import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH_VAULT_REQUEST]: isLoading,
  [actionTypes.FETCH_VAULT_SUCCESS]: isEnding,
  [actionTypes.FETCH_VAULT_FAILURE]: isEnding,
});
